export const CRITERIA = 'CRITERIA';
export const IMPORT = 'IMPORT';
